import React, { Component } from 'react';

import { Link, withRouter } from 'react-router-dom';

import { api } from '../../../services/api';
import { authService } from '../../../services/auth';
import constants from '../../../app.constants';
import { session } from '../../../services/session';

import LoginNav from './new-login-nav';

import './terms-conditions.scss';

class TermsConditions extends Component {
	constructor(props) {
		super(props);

		this.Api = api;
		this.Auth = authService;
		this.Constants = constants;
		this.Session = session;
	}

	acceptTerms() {
		const baseUrl = constants.API_BASE_URL;
		const apiEndpoint = constants.PUBLISHER_API_ENDPOINT;
		const orgId = this.Session.orgId;

		// /api/v0/publishers/:orgId/terms_conditions/accept/
		const acceptTermsConditionsRoute = `${baseUrl}${apiEndpoint}${orgId}/terms_conditions/accept/`;

		this.Api.put(acceptTermsConditionsRoute).then(() => {
			this.Auth.loadTermsConditions();
		}).then(() => {
			this.props.history.push('/v2/publisher/account/setup');
		});
	}

	rejectTerms() {
		this.Auth.logout(true);
	}

	render() {
		const isMobile = this.props.isMobile;
		const isOrgAdmin = this.Session.isOrgAdmin;

		const termsConditions = (
			<div className="terms-conditions-content">
				<div className="terms-conditions-header">
					<h1 className="main-header">
						Terms & Conditions
					</h1>
					<div className="terms-conditions-intro">
						<p>
							These Terms and Conditions ("Agreement") set forth the terms and conditions under
							which The Narrativ Company, Inc., a Delaware corporation with its primary place of
							business at 335 Madison Avenue, 16th Floor, New York, New York 10017 (“Narrativ” “we,”
							“our” or “us”) provides Service and Narrativ Technology (each defined below) to
							publishers (“Publisher” “you” or “your”). Narrativ and Publisher are sometimes
							referred to herein individually as a “Party” and together as the “Parties”.
						</p>
						<p>
							This Agreement constitutes a legally binding contract between Narrativ and you.
							Therefore, you should read this Agreement carefully. By clicking the “I Agree to the
							Terms & Conditions” box, you acknowledge that you have read and agree to all of the
							terms and conditions set forth in this Agreement. If you are entering into this
							Agreement on behalf of a company or other organization, you hereby warrant that you
							are authorized to enter into this Agreement on behalf of such company or other organization.
						</p>
					</div>
					<p className="date-modified">
						Last modified: October 17, 2017
					</p>
				</div>

				<div className="terms-conditions-text">
					<ol className="terms-conditions-sections">
						<li>
							<h2 className="section-header">
								Definitions
							</h2>
							<p>
								For purposes of this Agreement, the following terms have the following meanings:
							</p>
							<ol className="section-list" type="a">
								<li>
									"Customer" means an end user who interacts with SmartLinks or SmartShop Units
									placed on a Digital Property.
								</li>
								<li>
									"Digital Properties" means any websites, newsletters or other digital content
									that you own or have authority from the owner to modify.
								</li>
								<li>
									"Editorial Content" means all material, messages, articles, comments, images,
									sounds, and other materials and content accessible on or through the Digital
									Property.
								</li>
								<li>
									"Merchant" means an entity that sells goods or services.
								</li>
								<li>
									"Merchant Offerings" means goods or services you link to in Editorial Content.
								</li>
								<li>
									“Narrativ API” is the API developed by Narrativ to be used in conjunction with
									the Service only at the request of the client, for example to access data from
									our platform.
								</li>
								<li>
									"Narrativ Browser Extension" means the Chrome extension provided to you by
									Narrativ, which you use to create SmartLinks.
								</li>
								<li>
									"Narrativ Javascript Code" means the code provided to you by Narrativ which, when
									added to a website, will enable the use of the Service on the website.
								</li>
								<li>
									"Narrativ Technology" means any technology we make available to you through the
									Service including, without limitation, the Narrativ API, the Narrativ Browser
									Extension, the Narrativ Javascript Code, SmartLinks, and/ or SmartShop Units.
								</li>
								<li>
									"Service" means the Narrativ real-time bidding and placement platform and any
									other services offered by Narrativ from time to time.
								</li>
								<li>
									"SmartLink" is a Narrativ tagged hyperlink, updated by the Service, that
									facilitates the dynamic online referral by the Publisher to a Merchant and
									records the sales a ctivity between such referral and Merchant.
								</li>
								<li>
									"SmartShop Unit" is an advertising widget provided by Narrativ involving images,
									video, text and/or other content that may or may not contain SmartLinks.
								</li>
							</ol>
						</li>

						<li>
							<h2 className="section-header">
								Registration and Service
							</h2>
							<ol className="section-list" type="a">
								<li>
									Narrativ will provide you with account access information, which includes a
									temporary password that you may update ("Password"). You may be required to
									provide additional information that will assist in authenticating your identity
									when you log into your account in the future ("Unique Identifiers"). When
									registering for an account with Narrativ, you must provide true, accurate,
									current, and complete information. You are solely responsible for the
									confidentiality and use of your Password and Unique Identifiers, as well as for
									any use, misuse, or communications relating to your account or the Services. You
									will promptly inform Narrativ of any need to deactivate a Password or change any
									Unique Identifier. Narrativ reserves the right to delete or change your Password
									or Unique Identifier at any time and for any reason. Narrativ will not be liable
									for any loss or damage caused by any deletion, change, or unauthorized use of
									your account.
								</li>
								<li>
									Once your account is set up, Narrativ will provide you with the Narrativ
									Technology, which you will use to access the Service.
								</li>
								<li>
									SmartLinks can be created on your site via the Narrativ Browser Extension or by
									putting the Narrativ Javascript Code on your site to automatically rewrite agreed
									upon commerce hyperlinks or text elements on the page e.g., price and merchant
									name.
								</li>
								<li>
									Where you choose to implement the Narrativ Javascript Code on your site for the
									purposes of automatically creating SmartLinks, you agree that you consent to any
									update of your hyperlinks via the Narrativ Technology, unless you indicate
									explicitly that particular links or categories of links should not be updated,
									including by using the lock button on the chrome extension or via appending
									hashtags to the URL such as #donotsmartlink.
								</li>
								<li>
									The use of the Narrativ Technology is prohibited on digital properties that you
									do not own, control or have legal authority to modify.
								</li>
								<li>
									Narrativ may deny, suspend or cancel the Service or Narrativ Technology on any
									Digital Property at any time and for any reason in its sole and complete
									discretion. Narrativ will not be liable for any loss or damage caused by such a
									denial, suspension or cancellation.
								</li>
							</ol>
						</li>

						<li>
							<h2 className="section-header">
								Subscription and Intellectual Property
							</h2>
							<ol className="section-list" type="a">
								<li>
									Subject to your continued compliance with the terms and conditions of this
									Agreement, Narrativ grants you a non-exclusive, non-transferable limited right to
									use the Service and the Narrativ Technology on the Digital Properties during the
									term of this Agreement.
								</li>
								<li>
									As between the Parties, Narrativ is and will remain the sole and exclusive owner
									of all right, title, and interest in and to the Service and the Narrativ
									Technology, including, without limitation, all source code, object code,
									operating instructions, and all interfaces developed for or relating to the same,
									together with all modifications, enhancements, revisions, changes, copies,
									partial copies, translations, compilations, improvements, and derivative works
									thereof and thereto, and including all intellectual property rights embodied in
									any of the foregoing.
								</li>
								<li>
									You will not permit or assist any third party to, nor will you attempt to (i)
									reverse engineer, decompile or otherwise attempt to discover the source code of
									any aspect of the Narrativ Technology, (ii) interfere with the operation of the
									Service or the Narrativ Technology; or (iii) use the Service or the Narrativ
									Technology in any way other than what has been expressly authorized in this
									Agreement.
								</li>
								<li>
									You claim no rights with respect to any of the aforementioned except for the
									limited rights expressly set forth in Section 3(a) above.
								</li>
							</ol>
						</li>

						<li>
							<h2 className="section-header">
								Mutual Representations and Warranties
							</h2>
							<p className="section-paragraph">
								Each Party represents and warrants to the other that: (a) it has all right, power,
								and authority necessary to enter into this Agreement and perform its obligations
								hereunder without the need for any consents or approvals not yet obtained; (b) its
								performance of this Agreement, and the other Party’s exercise of its rights under
								this Agreement, will not breach or violate any other obligation to which it may be
								bound; and (c) it will comply with all applicable laws, regulations, orders and
								other requirements of any governmental authority of competent jurisdiction in its
								performance of this Agreement.
							</p>
						</li>

						<li>
							<h2 className="section-header">
								Publisher Representations, Warranties and Responsibilities
							</h2>
							<ol className="section-list" type="a">
								<li>
									Publisher is solely responsible for all matters related to the Editorial Content
									and the operation and maintenance of the Digital Properties, including, without
									limitation: (i) creating and posting Editorial Content and embedding SmartLinks
									in the Editorial Content; (ii) the accuracy and appropriateness of all Editorial
									Content (including, without limitation, all information regarding Merchants and
									Merchant Offerings); (iii) ensuring that all Editorial Content does not infringe
									upon or misappropriate any third party intellectual property or other rights; and
									(iv) ensuring that all Editorial Content is not obscene, defamatory, libelous,
									slanderous, or otherwise illegal.
								</li>
								<li>
									Publisher represents and warrants that (i) it will comply with all applicable
									laws, rules, regulations, regulatory guidelines, and other requirements
									applicable to the Editorial Content and the operation and maintenance of the
									Digital Properties, including without limitation, all applicable Federal Trade
									Commission (“FTC”) rules, guides and requirements and all applicable Digital
									Advertising Alliance (“DAA”) self-regulatory requirements; (ii) it will comply
									with any applicable Merchant terms and conditions and policies, to the extent
									applicable to Publisher’s operations and use of the Service and Narrativ
									Technology; (iii) it is the owner of the Digital Properties or is legally
									authorized to act on behalf of the owner of each Digital Property; (iv) the
									Digital Properties do not contain any computer instructions, circuitry or other
									technology whose purpose or effect is to disrupt, damage or interfere with
									computer or communications facilities or equipment, including without limitation,
									any code containing viruses, Trojan horses, worms, backdoors, trapdoors, time-out
									devices or similar destructive or harmful code; and (v) it will not take any
									action or encourage any third party to generate impressions or clicks through any
									automated, deceptive, fraudulent or other invalid means.
								</li>
							</ol>
						</li>

						<li>
							<h2 className="section-header">
								Merchant Network
							</h2>
							<p className="section-paragraph">
								Upon obtaining account access, you will be given access to a network of merchants
								from which you will be able to exclude any specific merchants you do not want
								included in your network of Merchants. You acknowledge and agree that once you have
								chosen your network of Merchants, Narrativ, through information derived from those
								Merchants and through its Service, will determine to which Merchants any particular
								SmartLink that you place in Editorial Content will link.
							</p>
						</li>

						<li>
							<h2 className="section-header">
								Fee
							</h2>
							<ol className="section-list" type="a">
								<li>
									Narrativ will pay you a fee (the "Fee") equal to (i) any revenue Narrativ
									receives from Merchants on account of clicks on SmartLinks in your Editorial
									Content, minus a commission of 40% and any applicable taxes, with no guaranteed
									minimum applicable and (ii) for all SmartShop Units, standard rates (which may
									differ per Merchant), as set forth on your dashboard or in any insertion order
									signed between Publisher and Narrativ from time to time. Narrativ may reserve
									accrued unpaid advertising fees for a reasonable period of time to ensure that
									the correct amount is paid (for example, to account for any cancellations or
									returns).
								</li>
								<li>
									The Fee due to you for any given month will be paid within ninety (90) days of
									month end, provided, however, that Narrativ will not be required to pay any Fee
									until payment has actually been received by Narrativ from the applicable
									Merchant. You will be subject to a minimum threshold amount of One Hundred Twenty
									Dollars ($120.00) (the “Payment Threshold”) before any Fee will be paid to you
									for any particular month. Payment will be made in U.S. dollars. If the Payment
									Threshold has not been met for any particular month, the amount owed will be paid
									to you the next following month in which the cumulative amount owed meets the
									Payment Threshold.
								</li>
								<li>
									All data relevant to the Fee will be based solely on the Narrativ impression and
									click data reporting system. Narrativ’s calculations shall be final and binding
									on Publisher.
								</li>
								<li>
									Narrativ will collect all relevant details for tax purposes as necessary and
									specified by the tax code. Each Party shall be responsible for paying any income
									taxes due on revenue earned by such Party pursuant to this Agreement.
								</li>
								<li>
									Publisher will use its best efforts to meet with the Narrativ team from time to
									time to discuss ways to optimize use of the Service on Digital Properties,
									including ways to improve CPCs, clicks, CTR, and number of new links.
								</li>
							</ol>
						</li>

						<li>
							<h2 className="section-header">
								Indemnity
							</h2>
							<p className="section-paragraph">
								You will indemnify, defend and hold harmless Narrativ and its officers, directors,
								shareholders, employees and agents from and against any and all liabilities, losses,
								damages and expenses (including reasonable attorneys' fees and disbursements)
								resulting from or based upon (i) any claim that the Editorial Content or any
								Digital Property infringes or misappropriates any third party intellectual property
								rights; (ii) breach of any obligation, promise, representation or warranty made by
								you in this Agreement; or (iii) any claim made by any Customer or other third party
								arising from your use of the Service or Narrativ Technology, unless such claim is
								due to Narrativ's gross negligence or willful misconduct.
							</p>
						</li>

						<li>
							<h2 className="section-header">
								Privacy and Compensation Disclosure
							</h2>
							<ol className="section-list" type="a">
								<li>
									In connection with the performance of its obligations under this Agreement,
									Narrativ may collect, use, and disclose data in accordance with Narrativ’s
									privacy policy, which can be found at
									<Link to="/v2/privacy-policy">
										https://dashboard.narrativ.com/v2/privacy-policy
									</Link>. Please review these carefully.
								</li>
								<li>
									Publisher acknowledges and agrees that it is Publisher’s responsibility to
									disclose to all users of the Digital Properties (including Customers) Publisher’s
									privacy practices and policies with respect to information collected from such
									users and the collection of fees relating thereto. Publisher agrees, that at all
									times during the term of this Agreement, Publisher will adhere to the DAA
									Self-Regulatory Principles for Online Behavioral Advertising and Multi-Site Data
									Collection (collectively “Self-Regulatory Principles”). Consistent with the
									Self-Regulatory Principles, Publisher shall include a conspicuous mechanism on
									each Digital Property through which users (including Customers) can opt-out of
									interest-based advertising from participating companies, which include Narrativ.
								</li>
								<li>
									Publisher will not collect or enable the collection of Personally Identifiable
									Information in connection with the SmartLinks without the prior written consent
									of the Customer. “Personally Identifiable Information” is any information used or
									intended to be used to identify a particular individual, including name, postal
									address, telephone number, email address, financial account number, and
									government-issued identifier.
								</li>
								<li>
									Publisher acknowledges and agrees that in connection with the provision of the
									Service and Narrativ Technology, to the extent any Merchant collects Personally
									Identifiable Information that is voluntarily provided to Merchant by Customers,
									such information is the property of the Merchant and is subject to the Merchant’s
									privacy policy.
								</li>
								<li>
									Publisher agrees to disclose all compensation received on each Digital Property
									through the Service and the Narrativ Technology in accordance with applicable FTC
									guidelines and any other applicable laws, rules, regulations or guidelines.
								</li>
							</ol>
						</li>

						<li>
							<h2 className="section-header">
								Collection, Usage and Sharing of Data
							</h2>
							<ol className="section-list" type="a">
								<li>
									For any page containing Narrativ Technology on the Digital Properties, Narrativ
									collects information relating to any interaction between a user and Narrativ
									Technology, and other information such as page load data and impressions (the
									“Narrativ Data”).
								</li>
								<li>
									Narrativ is the sole and exclusive owner of Narrativ Data and may use it in any
									way permitted under applicable law, including without limitation, to improve the
									overall quality of Narrativ’s services, and may sell, lease, or otherwise share
									Narrativ Data with third parties, including Narrativ Data that is unique to your
									Digital Properties (and that identifies your Digital Properties).
								</li>
								<li>
									To the extent there is any conflict between the provisions of Section 10 and the
									terms of Narrativ’s privacy policy, the terms of this Section 10 shall prevail.
								</li>
							</ol>
						</li>

						<li>
							<h2 className="section-header">
								Disclaimer of Warranties
							</h2>
							<p className="section-paragraph">
								THE SERVICE AND NARRATIV TECHNOLOGY ARE PROVIDED 'AS IS.' NARRATIV DOES NOT MAKE
								ANY REPRESENTATIONS OR WARRANTIES IN CONNECTION WITH THE SERVICE, NARRATIV
								TECHNOLOGY, THE MERCHANTS ACCESSIBLE THROUGH THE SERVICE, THE OPERATION OF ANY OF
								THE FOREGOING OR THE SERVICE BEING UNINTERRUPTED OR ERROR-FREE, OR OTHERWISE WITH
								RESPECT TO THIS AGREEMENT. NARRATIV EXPRESSLY DISCLAIMS ANY AND ALL EXPRESS,
								IMPLIED AND STATUTORY REPRESENTATIONS AND WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
								IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, NON-INFRINGEMENT, FITNESS FOR A
								PARTICULAR PURPOSE, ERROR-FREE OR UNINTERRUPTED OPERATION AND ANY WARRANTIES
								ARISING FROM A COURSE OF DEALING OR USAGE OF TRADE. TO THE EXTENT THAT NARRATIV MAY
								NOT, AS A MATTER OF APPLICABLE LAW, DISCLAIM ANY SUCH WARRANTY, THE SCOPE AND
								DURATION OF SUCH WARRANTY WILL BE MINIMUM REQUIRED BY APPLICABLE LAW.
							</p>
						</li>

						<li>
							<h2 className="section-header">
								Limitation of Liability
							</h2>
							<p className="section-paragraph">
								IN NO EVENT WILL NARRATIV BE LIABLE TO YOU OR ANY THIRD PARTY (INCLUDING, BUT NOT
								LIMITED TO, ANY CUSTOMER) FOR ANY LOST PROFITS OR LOST REVENUE, OR FOR ANY INDIRECT,
								INCIDENTAL, SPECIAL, PUNITIVE, EXEMPLARY OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR
								IN CONNECTION WITH THIS AGREEMENT, INCLUDING WITHOUT LIMITATION, THE SERVICE,
								Narrativ TECHNOLOGY, AND THE USE OF ANY SOFTWARE, EXTENSIONS, CODE, OPERATING
								INSTRUCTIONS, INTERFACES, OR LINKS PROVIDED IN CONNECTION THEREWITH. IN NO EVENT
								WILL NARRATIV’S LIABILITY FOR DAMAGES OR ALLEGED DAMAGES UNDER THIS AGREEMENT,
								WHETHER IN CONTRACT, TORT OR ANY OTHER LEGAL THEORY, EXCEED THE FEES PAID TO YOU BY
								NARRATIV UNDER THIS AGREEMENT DURING THE SIX (6) MONTH PERIOD IMMEDIATELY PRECEDING
								SUCH CLAIM, OR FIVE HUNDRED DOLLARS ($500.00), WHICHEVER IS LESS.
							</p>
						</li>

						<li>
							<h2 className="section-header">
								Term and Termination
							</h2>
							<p className="section-paragraph">
								This Agreement may be terminated by either party upon 30 business days’ notice to
								the other party or immediately upon insolvency or incurable breach by the other
								party. In the event of termination of this Agreement for any reason other than your
								breach of this Agreement, Narrativ will pay outstanding Fees due to you in
								accordance with the terms of this Agreement. Upon termination of this Agreement for
								any reason, you will immediately cease use of, and promptly remove from the Digital
								Properties, all instances of the Service and promptly return to Narrativ, or at
								Narrativ's request destroy, any and all copies of the Narrativ Technology, or any
								other information relating to the intellectual property of Narrativ in your
								possession. Except for Narrativ’s obligation to provide the Service and Narrativ
								Technology, all other provisions of this Agreement shall survive termination of
								this Agreement.
							</p>
						</li>

						<li>
							<h2 className="section-header">
								Confidentiality
							</h2>
							<p className="section-paragraph">
								“Confidential Information” means any information relating to or disclosed prior to
								or in the course of the Agreement that is or should reasonably be understood to be
								confidential. Confidential Information includes, without limitation, the terms of
								this Agreement and information regarding the Service and Narrativ Technology. The
								receiving Party will use the same care to protect Confidential Information as it
								uses for its own similar information, but in no event less than reasonable care,
								and will use Confidential Information only for the purpose of fulfilling its
								obligations under this Agreement. The receiving Party will promptly return or
								destroy the other Party’s Confidential Information upon request of the other Party.
								Confidential Information does not include information that (a) is or becomes part
								of the public domain through no fault of the receiving Party; (b) was already in
								possession of the receiving Party; or (c) was independently developed by the
								receiving Party without violating this
								Agreement.
							</p>
						</li>

						<li>
							<h2 className="section-header">
								Miscellaneous
							</h2>
							<ol className="section-list" type="a">
								<li>
									Severability. In the event that any portion of this Agreement is held to be
									invalid or unenforceable, then such portion will be construed in accordance with
									the applicable law as nearly as possible to reflect the original intentions of
									the Parties, and the remainder of this Agreement will remain in full force and
									effect.
								</li>
								<li>
									Headings. The paragraph headings herein are provided only for reference and will
									have no effect on the construction or interpretation of this Agreement.
								</li>
								<li>
									Waivers. No failure or delay by you or Narrativ in exercising any right or remedy
									under this Agreement will operate as a waiver of such right or remedy, unless in
									writing.
								</li>
								<li>
									Governing Law. This Agreement will be governed by and construed in accordance
									with the laws of the State of New York. Except for proceedings commenced by us to
									protect our intellectual property or confidential information which may be
									brought in any court of competent jurisdiction, the Parties mutually agree that
									any and all disputes arising hereunder will be resolved exclusively by state or
									federal courts located in New York City, New York.
								</li>
								<li>
									Independent Contractors. You and Narrativ are independent contractors and neither
									will be deemed to be an employee, agent, partner, joint venturer or legal
									representative of the other.
								</li>
								<li>
									Modifications. Narrativ reserves the right to update or modify this Agreement at
									any time and from time to time. When Narrativ makes changes to this Agreement,
									the 'last updated' date at the top of this Agreement will be revised. If there
									are material changes to this Agreement, we will notify you of any such
									modifications by posting a message on the Narrativ website. You should
									periodically review this Agreement. YOUR CONTINUED USE OF THE SERVICES FOLLOWING
									THE EFFECTIVE DATE OF SUCH NOTICE WILL CONSTITUTE YOUR ACCEPTANCE OF THE
									MODIFICATIONS. IF ANY MODIFICATION IS UNACCEPTABLE TO YOU, YOUR ONLY RECOURSE IS
									TO TERMINATE THIS AGREEMENT IN ACCORDANCE WITH SECTION 13.
								</li>
								<li>
									Assignments. You may not assign this Agreement without the prior written consent
									of Narrativ.
								</li>
								<li>
									Force Majeure. Neither you nor Narrativ will be deemed in breach of this
									Agreement for any failure or delay in performance to the extent caused by reasons
									beyond your reasonable control, including, but not limited to, fire, flood,
									accident, earthquakes, telecommunications line failures, electrical outages,
									network failures, acts of God, or labor disputes.
								</li>
								<li>
									Publicity and Use of Logo. Narrativ may refer to you and any of the Digital
									Properties as a publisher and user of the Services. In connection therewith,
									Narrativ may use your corporate logo. Any goodwill arising from the use of such
									logo shall inure solely to you. With your prior consent, which may be given via
									e-mail, Narrativ may use your logo, testimonials, quotes, name, image, and
									likeness (or your representative who has provided such testimonial or quote to
									Narrativ) to advertise, promote, and market the Services and Narrativ or in
									connection with Merchant re-targeting campaigns referencing your product
									recommendations.
								</li>
								<li>
									Entire Agreement. We reserve the right to modify the terms and conditions
									contained in this Agreement at any time, at our sole discretion, by posting the
									revised terms on your dashboard or by sending you notice of such modification by
									email to the primary address associated with your Narrativ account. Your
									continued use of The Service and The Narrativ Technology following the effective
									date of such a notice will constitute your acceptance of these modifications.
									Together with any related insertion orders, this Agreement contains the entire
									agreement of the Parties concerning the subject matter hereof and supersedes all
									existing agreements and all other oral, written or other communication between
									the Parties concerning its subject matter. In the event of a conflict between the
									terms of this Agreement and the terms of an insertion order, the terms of the
									insertion order shall prevail.
								</li>
							</ol>
						</li>
					</ol>
				</div>
			</div>
		);

		const orgAdmin = (
			<div className="admin">
				{termsConditions}
				<div className="content-footer">
					<p>
						I have read and agree to the Terms & Conditions
					</p>
					<button className="accept" onClick={this.acceptTerms.bind(this)}>Agree</button>
					<button className="cancel" onClick={this.rejectTerms.bind(this)}>Cancel</button>
				</div>
			</div>
		);

		const orgUser = (
			<div className="user">
				<div className="terms-conditions-content">
					<div className="terms-conditions-text">
						<h1>
							Your account is locked until a primary user accepts the terms and conditions.
						</h1>
						<p>
							Please reach out to the Narrativ lead within your organization or contact us at&nbsp;
							<a href="mailto:info@narrativ.com">info@narrativ.com</a>.
						</p>
						<button className="cancel" onClick={this.rejectTerms.bind(this)}>Back</button>
					</div>
				</div>
			</div>
		);

		return (
			<div className={`terms-conditions${isMobile ? ' mobile' : ''}`}>
				<LoginNav isMobile={isMobile} />
				<div className="content">
					<div className="content-header">
						<span className="text">Sign in</span>
						<span className="line" />
					</div>
					{isOrgAdmin ? orgAdmin : orgUser}
				</div>
			</div>
		);
	}
}

export default withRouter(TermsConditions);
